export function CreateInsightSwitchBlockText(text)
{
    let div = document.createElement("div");
    div.classList.add("insight_container_switch");
    div.textContent = text;

    return div;
}